import { NotificationStore, PendingWorkflow } from './notificationTypes'
import { NotificationActions, NotificationActionTypes } from './notificationActions'
import {
  ClientActionTypes,
  ClientCrudEventAction,
  ClientEventAction,
  ClientLoginAction,
  EventResponseAction,
  ServerActionTypes,
  ClientSubscribeAction,
  ClientUnsubscribeAction,
  ClientDatabaseReportAction,
  ClientPermissionsReportAction,
  ClientUpdateCollateralsAction,
  ClientUpdateIssuerOrganisationAction
} from 'api'

const initialState: NotificationStore = {
  growls: [],
  dialogs: [],
  pendingActions: {},
  pendingWorkflows: {}
}

type NotificationReducerActions =
  | NotificationActions
  | ClientEventAction
  | ClientDatabaseReportAction
  | ClientPermissionsReportAction
  | ClientCrudEventAction
  | ClientSubscribeAction
  | ClientUnsubscribeAction
  | ClientLoginAction
  | EventResponseAction
  | ClientUpdateCollateralsAction
  | ClientUpdateIssuerOrganisationAction

export function notificationReducer(state: NotificationStore = initialState, action: NotificationReducerActions): NotificationStore {
  switch (action.type) {
    case NotificationActionTypes.GROWL_CREATE: {
      const growls = state.growls.concat(action.payload)
      return { ...state, growls }
    }

    case NotificationActionTypes.GROWL_DISMISS: {
      const growls = state.growls.filter(growl => growl.id !== action.payload.id)
      return { ...state, growls }
    }

    case NotificationActionTypes.DIALOG_CREATE: {
      const dialogs = state.dialogs.concat(action.payload)
      return { ...state, dialogs }
    }

    case NotificationActionTypes.DIALOG_DISMISS: {
      const dialogs = state.dialogs.filter(dialog => dialog.id !== action.payload.id)
      return { ...state, dialogs }
    }

    case NotificationActionTypes.CREATE_PENDING_WORKFLOW: {
      const { workflowType, correlatedResponseCallback } = action.payload
      const pendingWorkflows = {
        ...state.pendingWorkflows,
        [action.payload.correlationId]: {
          workflowType,
          correlatedResponseCallback
        }
      }

      return {
        ...state,
        pendingWorkflows
      }
    }

    case NotificationActionTypes.REMOVE_PENDING_WORKFLOW: {
      const pendingWorkflows = Object.keys(state.pendingWorkflows).reduce((acc, correlationId) => {
        if (correlationId !== action.payload.correlationId) {
          acc[correlationId] = state.pendingWorkflows[correlationId]
        }
        return acc
      }, {} as Record<string, PendingWorkflow>)

      return { ...state, pendingWorkflows }
    }

    case ClientActionTypes.EVENT_MESSAGE:
    case ClientActionTypes.CRUD_EVENT_MESSAGE:
    case ClientActionTypes.DATABASE_REPORT_MESSAGE:
    case ClientActionTypes.PERMISSIONS_REPORT:
    case ClientActionTypes.SUBSCRIBE_MESSAGE:
    case ClientActionTypes.UNSUBSCRIBE_MESSAGE:
    case ClientActionTypes.LOGIN_MESSAGE:
    case ClientActionTypes.UPDATE_COLLATERALS:
    case ClientActionTypes.UPDATE_ISSUER_ORGANISATION: {
      const pendingActions = {
        ...state.pendingActions,
        [action.payload.correlationId]: action
      }

      return {
        ...state,
        pendingActions
      }
    }

    case ServerActionTypes.EVENT_RESPONSE: {
      const { [action.payload.correlationId]: pendingAction, ...pendingActions } = state.pendingActions
      let dialogs = state.dialogs
      let growls = state.growls

      return {
        ...state,
        dialogs,
        growls,
        pendingActions
      }
    }

    default: {
      return state
    }
  }
}
